import React from 'react';
import { Typography, Card, Tag } from 'antd';
import { useInView } from 'react-intersection-observer';
import { getName } from 'utils/collection-utils';
import { useCollectionSpots } from 'api/collection-spots.api';
import CollectionStatus from './CollectionStatus';
import CollectionSpots from './CollectionSpots.jsx';
import './style.css';

const { Text } = Typography;

type CollectionProps = {
    collection: Collection;
    filterBySources: Source[];
};

function Collection({ collection, filterBySources }: CollectionProps) {
    const [ref, inView] = useInView({
        triggerOnce: true,
    });
    const { collectionSpots } = useCollectionSpots(collection.id as Id);

    return (
        <div className='collection' ref={ref}>
            <Card
                bodyStyle={{ padding: 0 }}
                headStyle={{ paddingRight: 0, paddingLeft: 16 }}
                title={
                    <div className='collection__title'>
                        <CollectionStatus collection={collection} className='mr-s' />
                        <div className='collection__header-title'>
                            {getName(collection)}

                            {!!collectionSpots?.length && (
                                <div className='ml-s'>
                                    <Tag>{collectionSpots?.length} Spots</Tag>
                                </div>
                            )}

                            {collection.description && (
                                <>
                                    <Text
                                        className='ml-xs'
                                        type='secondary'
                                        ellipsis={true}
                                        title={collection.description}>
                                        {collection.description}
                                    </Text>
                                </>
                            )}
                        </div>
                    </div>
                }
                extra={null}>
                <div className='collection__content'>
                    {inView && <CollectionSpots collection={collection} filterBySources={filterBySources} />}
                </div>
            </Card>
        </div>
    );
}

export default Collection;
